/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useFilteredVpcs } from "./hooks";
import { VpcSubnetSidebar } from "./VpcSubnetSidebar";

type Props = {
  isOpen: boolean;
  excludeItems?: string[];
  onSubmit: (value: string) => void;
  onClose: () => void;
  handleDelete: (subnetIds: string[]) => void;
};

export function VpcSubnetSelector({
  isOpen,
  excludeItems = [],
  onSubmit,
  onClose,
  handleDelete,
}: Props) {
  const {
    error,
    loading,
    filteredVpcs,
    page,
    pageSize,
    vpcsCount,
    setPage,
    setVpcSearch,
  } = useFilteredVpcs();

  const filteredInitialSubnets = excludeItems.filter((item) =>
    item.startsWith("subnet-")
  );

  return (
    <VpcSubnetSidebar
      loading={loading}
      error={error}
      isOpen={isOpen}
      vpcs={filteredVpcs}
      initialSubnets={filteredInitialSubnets}
      page={page}
      pageSize={pageSize}
      vpcsCount={vpcsCount ?? 0}
      onClose={onClose}
      onSubmit={onSubmit}
      onDelete={handleDelete}
      setPage={setPage}
      setVpcSearch={setVpcSearch}
    />
  );
}
